import { theme } from '@ahmdigital/ui';
import styled from 'styled-components';

const { colors } = theme;

export const MetadataWrapper = styled.div<{ isLeftAligned?: boolean }>`
  align-items: ${({ isLeftAligned }) => (isLeftAligned ? 'flex-start' : 'center')};
  display: flex;
  flex-direction: column;
  font-weight: bold;
  justify-content: center;
  margin-bottom: 1rem;
  row-gap: 1rem;
`;

export const MetadataTextWrapper = styled.div<{ hasTags: boolean; isLeftAligned?: boolean }>`
  color: ${colors.grey50};
`;
